import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ChapterListItem } from 'components';
import NotesHighlightsListCard from './NotesHighlightsListCard';
import { sortByIndexOfType } from 'utilities';
import { areListItemsEqual } from 'utilities/sideNavUtils';
import { OfflineValuesContext } from 'contexts';

const useStyles = makeStyles((theme) => ({
  listItem: {
    marginLeft: theme.spacing(2),
    borderBottom: `solid 1px ${theme.palette.grey[300]}`, // #E5E5E5
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
}));

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.isOffline !== nextProps.isOffline) {
    return false;
  }

  const itemPropsToCompare = ['color', 'userText'];

  return areListItemsEqual(
    prevProps.children,
    nextProps.children,
    itemPropsToCompare,
  );
};

const NotesHighlightsListItem = memo(
  ({ children, isOffline, topLevelMarker, ...props }) => {
    const classes = useStyles();
    const { markersDownloaded } = useContext(OfflineValuesContext);
    const label = topLevelMarker?.label ?? 'No Chapter';
    const index = topLevelMarker?.index ?? 'no-chapter';
    const chapterTitle = (
      <div className={'noTranslate'}>{`${label} (${children.length})`}</div>
    );
    const sortedChildren = sortByIndexOfType(children, 'page');

    return (
      <ChapterListItem
        ariaLabelChapterTitle={label}
        id={`notes-highlights-${index}`}
        isNavItem={false}
        shouldHaveLoadMoreButton={true}
        title={chapterTitle}
        {...props}
      >
        {sortedChildren &&
          sortedChildren.map((contentItem) => {
            return (
              <li
                className={classes.listItem}
                key={`note-card-${contentItem.id}`}
              >
                <NotesHighlightsListCard
                  contentItem={contentItem}
                  isSnippetLinkAvailable={
                    !isOffline || markersDownloaded?.has(contentItem?.marker)
                  }
                />
              </li>
            );
          })}
      </ChapterListItem>
    );
  },
  arePropsEqual,
);

NotesHighlightsListItem.propTypes = {
  children: PropTypes.array.isRequired,
  topLevelMarker: PropTypes.object,
};

export default NotesHighlightsListItem;
